import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getSlideTypesHostingRate: {
    method: 'GET',
    url: `${configs.baseUrl}/api/slide/slide-types-hosting-rate`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// `{ data: { [slideType]: { hostingRatePercent, pickCount, hostedCount } } }`, keyed by the
// picker item's `type`; types with too few picks are omitted by the endpoint.
const getSlideTypesHostingRate = async () => {
  const res = await resource.getSlideTypesHostingRate()
  if (!res.ok) throw Object.assign(new Error(`HTTP ${res.status}`), { response: res })
  return res.body
}

export default { initResource, getSlideTypesHostingRate }
